<template>
	<div class="page-content-wrapper">
		<div class="container-fluid">
			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-body" style="margin-bottom: 30px;">
							<h5>
								<i class="fas fa-users"></i> Selecciona el alumno
							</h5>
							<div class="mt-4">
								<v-select v-if="listadoAlumnosBusqueda != undefined && !globalLoadingMulticampus" placeholder="Listado Alumnos..." :options="listadoAlumnosBusqueda" label="nombre" v-model="selected" @input="seleccionAlumno(listadoAlumnosBusqueda)">
									<template slot="option" slot-scope="option">
										{{ option.nombre }}
									</template>
								</v-select>
								<PuSkeleton v-else :count="3"></PuSkeleton> 
								<small>Selecciona el alumno, para poder visualizar la información personal.</small>
							</div>
						</div>
					</div>
				</div>
				<!-- end col -->
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import alumno from "../../store/modules/alumno";

export default {
	data() {
		return {
			selected: "",
			listadoAlumno: [],
		};
	},
	computed:{
		...mapState('alumno',['jsonCoordinadora']),
		...mapState('alumno',['listadoAlumnosBusqueda']),
		...mapState("curso",["campusSeleccionadoMulti"]),
		...mapState("curso",["globalLoadingMulticampus"])
	},
	methods: {
		...mapActions("alumno", ["updateJsonAlumno"]),
		...mapActions("alumno", ["updateRegionJson"]),
		...mapActions("alumno", ["updateComunaJson"]),
		...mapActions("alumno", ["updateCampusJson"]),
		...mapActions("alumno", ["updateCursoJson"]),
		...mapActions('alumno',['updateEdicionAlumno']),
		...mapActions('alumno',['updateListadoAlumnosBusqueda']),
		seleccionAlumno() {
			this.updateJsonAlumno([]);
			const idAlumno = this.selected.idAlumno;

			this.getInfoAlumno(idAlumno);
		},
		async getDataAlumnos() {

            let url = "api/getAlumnosCampus";
			if(this.campusSeleccionadoMulti.idCampus != undefined){
				url = url + "/" + this.campusSeleccionadoMulti.idCampus;
			}
			const { data } = await this.axios.get(url);
			const { getAlumnos: alumnosCampus } = data;
			//this.listadoAlumno
			const listadoAlumno = alumnosCampus.map((alumno) => ({
				idAlumno: alumno.idAlumno,
				nombre: alumno.numeroDocumento + " | " + alumno.nombre,
			}));

			let alHash = {};
			this.listadoAlumno = listadoAlumno.filter((al) =>
				alHash[al.idAlumno] ? false : (alHash[al.idAlumno] = true)
			);
			this.updateListadoAlumnosBusqueda(this.listadoAlumno);
		},
		async getInfoAlumno(idAlumno) {
			if(idAlumno == undefined) return;
			const { data } = await this.axios.get(
				"api/getIdAlumno/" + idAlumno
			);

			//logica privilegios
			const {data:dataCurso} = await this.axios.get("api/getInfoAlumnoCurso/" + idAlumno);
			const {privilegios} = this.jsonCoordinadora;


			let ArrayPrivilegios = [];
			Object.entries(privilegios).forEach(([key, value]) => {
				ArrayPrivilegios.push({key, value});
			});

			
	
			const {getCurso} = dataCurso;
			const campusAlumnos = (ArrayPrivilegios.find(p=> getCurso.map(c=> c.idCampus === p.idCampus))).value;
			const edicionAlumno = campusAlumnos.edicionAlumno === 0 ? false : true;
			this.updateEdicionAlumno(edicionAlumno)

			//fin logica privilegios

			const { alumno } = data;
			//carga vuex
			this.updateJsonAlumno(alumno);
			this.getRegion(alumno.idPais);
			this.getComunas(alumno.idRegion);
			this.getCampusAlumno(idAlumno);
			this.getCursoAlumno(idAlumno);
		},
		async getCampusAlumno(idAlumno) {
			const { data } = await this.axios.get(
				"api/getCampusByAlumno/" + idAlumno
			);
			const { getCampus: campus } = data;
			this.updateCampusJson(campus);
		},
		async getCursoAlumno(idAlumno) {
			const { data } = await this.axios.get("api/getCursosAlumno/" + idAlumno);
			const { getCursos: cursos } = data;
			this.updateCursoJson(cursos);
		},
		async getRegion(idPais) {
			const { data } = await this.axios.get(
				"api/getRegionPais/" + idPais
			);
			const { getRegion: region } = data;

			const regiones = region.map((reg) => ({
				value: reg.idRegion,
				text: reg.nombreRegion,
			}));

			this.updateRegionJson(regiones);
		},
		async getComunas(idRegion) {
			const { data } = await this.axios.get(
				"api/getComunasRegion/" + idRegion
			);
			const { getComuna: comuna } = data;

			const comunas = comuna.map((com) => ({
				value: com.idComuna,
				text: com.nombreComuna,
			}));

			this.updateComunaJson(comunas);
		},
	},
	created() {
		this.getDataAlumnos();
	},
};
</script>
<style>
.vs__clear {
    fill: red !important;
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    margin-right: 8px;
}
</style>